package com.nonopn.skywatcher.common.app.pages.map

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.width
import androidx.compose.material.LocalContentColor
import androidx.compose.material3.DrawerDefaults
import androidx.compose.material3.DrawerState
import androidx.compose.material3.DrawerValue
import androidx.compose.material3.ModalNavigationDrawer
import androidx.compose.material3.rememberDrawerState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.LocalLayoutDirection
import androidx.compose.ui.unit.LayoutDirection
import androidx.compose.ui.unit.dp
import com.nonopn.skywatcher.common.app.home.HotPreviewApp
import com.nonopn.skywatcher.common.app.home.LocalApp
import com.nonopn.skywatcher.common.app.home.LocalIsPreview
import com.nonopn.skywatcher.common.app.pages.map.model.FakeMainScreenModel
import com.nonopn.skywatcher.common.app.pages.map.model.MainScreenModelImpl
import com.nonopn.skywatcher.common.app.pages.map.model.weather.ProbeStatus
import com.nonopn.skywatcher.common.app.pages.map.model.weather.WeatherReport
import com.nonopn.skywatcher.common.app.pages.map.view.RightColumn
import com.nonopn.skywatcher.common.app.pages.map.window.MainScreenLargeScreen
import com.nonopn.skywatcher.common.app.pages.map.window.MainScreenTinyScreen
import com.nonopn.skywatcher.common.app.pages.sentinels.ThunderDetection
import com.nonopn.skywatcher.common.app.pages.sentinels.ThunderDetectionWithMetadata
import com.nonopn.skywatcher.design.theme.AppColor
import com.nonopn.skywatcher.design.utils.LocalWindow
import com.nonopn.skywatcher.design.utils.WindowType
import de.drick.compose.hotpreview.HotPreview
import eu.codlab.compose.theme.LocalDarkTheme
import eu.codlab.viewmodel.rememberViewModel

@Composable
fun MainScreen(
    modifier: Modifier,
    thunderDetection: ThunderDetectionWithMetadata,
    fakeData: ProbeStatus? = null
) {
    val appModel = LocalApp.current
    val scope = rememberCoroutineScope()
    val model = if (LocalIsPreview.current) {
        FakeMainScreenModel(false, fakeData)
    } else {
        rememberViewModel { MainScreenModelImpl(appModel, thunderDetection) }
    }

    val lightningDrawerState = rememberDrawerState(DrawerValue.Closed)
    model.lightningDrawerState = lightningDrawerState
    model.scope = scope

    val color = if (LocalDarkTheme.current) {
        AppColor.WhiteCream
    } else {
        AppColor.BackgroundBlue
    }

    CompositionLocalProvider(
        LocalContentColor provides color,
    ) {
        ModalNavigationRightToLeft(
            drawerContent = {
                RightColumn(Modifier.width(250.dp).fillMaxHeight(), model)
            },
            gesturesEnabled = lightningDrawerState.isOpen,
            drawerState = lightningDrawerState
        ) {

            when (LocalWindow.current) {
                WindowType.SMARTPHONE_TINY -> MainScreenTinyScreen(modifier, model)
                WindowType.SMARTPHONE -> MainScreenTinyScreen(modifier, model)
                WindowType.PHABLET -> MainScreenLargeScreen(modifier, model)
                WindowType.TABLET -> MainScreenLargeScreen(modifier, model)
            }
        }
    }
}

@Composable
private fun DrawerContentWrapper(
    layoutDirection: LayoutDirection,
    content: @Composable () -> Unit,
) {
    CompositionLocalProvider(LocalLayoutDirection provides layoutDirection) {
        content()
    }
}

@Composable
private fun ModalNavigationRightToLeft(
    drawerContent: @Composable () -> Unit,
    gesturesEnabled: Boolean,
    drawerState: DrawerState,
    scrimColor: Color = DrawerDefaults.scrimColor,
    content: @Composable () -> Unit,
) {
    val originalDirection = LocalLayoutDirection.current
    val reversedDirection = when (LocalLayoutDirection.current) {
        LayoutDirection.Ltr -> LayoutDirection.Rtl
        LayoutDirection.Rtl -> LayoutDirection.Ltr
    }

    CompositionLocalProvider(LocalLayoutDirection provides reversedDirection) {
        ModalNavigationDrawer(
            drawerContent = { DrawerContentWrapper(originalDirection, drawerContent) },
            gesturesEnabled = gesturesEnabled,
            drawerState = drawerState,
            scrimColor = scrimColor
        ) {
            CompositionLocalProvider(LocalLayoutDirection provides originalDirection) {
                content()
            }
        }
    }
}

@HotPreview(widthDp = 1200, heightDp = 800, darkMode = true)
@HotPreview(widthDp = 1200, heightDp = 800, darkMode = false)
@Composable
private fun MainScreenPreview() {
    HotPreviewApp(
        Modifier.fillMaxSize(),
        isDarkTheme = isSystemInDarkTheme(),
        isPreview = true
    ) {
        MainScreen(
            Modifier.fillMaxSize(),
            ThunderDetectionWithMetadata(
                ThunderDetection(
                    "",
                    "",
                    0.0,
                    0.0
                ),
                false
            ),
            ProbeStatus(
                // weatherResult = WeatherResult.fake(Condition.fake),
                report = WeatherReport.fake()
            )
        )
    }
}